import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';
import {Observable} from 'rxjs';
import {Sales} from '@app/domain/sales';
import {TotalCategory} from '@app/domain/total-category';
import {Movements} from "@app/domain/movements";
import { TotalVendors } from '@app/domain/total-vendors';
import { TotalUsuarioPedidos } from '@app/domain/total-usuario-pedidos';


@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    baseUrl: string = environment.endpointApi;

    constructor(private http: HttpClient) {
    }

    findAllSales(params): Observable<Sales[]> {
        return this.http.get<Sales[]>(`${this.baseUrl}/sales-months?${params}`);
    }

    findAllMovements(params): Observable<Movements[]> {
        return this.http.get<Movements[]>(`${this.baseUrl}/movements-months?${params}`);
    }

    findAllTotalCategories(params): Observable<TotalCategory[]> {
        return this.http.get<Sales[]>(`${this.baseUrl}/total-categories?${params}`);
    }

    findAllTotalVendors(params): Observable<any> {
        return this.http.get<Sales[]>(`${this.baseUrl}/summary-vendedores?${params}`);
    }

    findAllTotalUsuariosPedidos(params): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/summary-usuarios-pedidos?${params}`);
    }

    getReportSalesByHours(params): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/sales-by-schedule?${params}`);
    }

}
